import { TimeField } from '@mui/x-date-pickers/TimeField';
import dayjs from 'dayjs';
import React from 'react';

const SubtitleTimeField = ({ value, onKeyDown, field, index, updateSub, rowData }) => {
    return (
        <TimeField
            id={`subTitleTimer${field}Input${index}`}
            value={dayjs('2022-04-17T' + value)}
            onKeyDown={(e) => onKeyDown(e, index, field)}
            format="HH:mm:ss"
            onChange={(event) => {
                const times = event['$d'];
                const dateObj = new Date(times);
                const timeString = dateObj.toLocaleTimeString([], { hour12: false });

                if (timeString !== 'Invalid Date') {
                    updateSub(rowData, { [field]: timeString });
                }
            }}
        />
    );
};

export default SubtitleTimeField;
